import { fetchCorporationSettingAPI } from '@/api/admin/setting';
import localforage from 'localforage';
import { useState, useCallback, useEffect } from 'react';
import { useTimezoneConverter } from './useTimezoneConverter';
import { CorporateSettingInfo } from '@/types/pages/admin/settings';

export const useCorporationSettings = ({ autoFetch = false } = {}) => {
    const [corporationSettings, setCorporationSettings] = useState<CorporateSettingInfo | null>(null);
    const [corporationTimezone, setCorporationTimezone] = useState<string | null>(null);

    const timezoneUtils = useTimezoneConverter(corporationTimezone);

    const fetchCorporationSettings = useCallback(async () => {
        const corporationId = await localforage.getItem<number>('corporation_id');

        if (!corporationId) {
            setCorporationSettings(null);
            setCorporationTimezone(null);
            return null;
        }

        const {
            data: { data, isSuccess },
        } = await fetchCorporationSettingAPI(corporationId);

        if (!isSuccess) {
            setCorporationSettings(null);
            setCorporationTimezone(null);
            return null;
        }

        setCorporationSettings(data);
        setCorporationTimezone(data.store_timezone || null);

        return data;
    }, []);

    useEffect(() => {
        if (!autoFetch) {
            return;
        }

        void fetchCorporationSettings();
    }, [autoFetch, fetchCorporationSettings]);

    return {
        corporationSettings,
        corporationTimezone,
        fetchCorporationSettings,
        ...timezoneUtils,
    };
};
